<template>
  <div class="px-8">
    <div class="mt-8 bg-white p-8 w-full" v-if="quesData.length">
      <div class="mb-1 question">
        <p class="text-sm text-center">
          Question {{ n + 1 }}/{{ quesData.length }}
        </p>
      </div>

      <div class="mb-10">
        <p class="text-black text-lg font-semibold text-center">
          {{ quesData[n].question }}
        </p>
      </div>
      <div class="mx-auto w-1/2">
        <b-card
          no-body
          class="rounded-lg p-2 pb-3 text-left mb-4 qcard"
          v-for="(items, index) in quesData[n].option.option"
          :key="'item -' + index"
        >
          <b-form-radio
            v-model="selected"
            :name="items.name"
            :value="items"
            :disabled="!!selected"
            @change="selectedQnA()"
          >
            <p class="font-normal">
              {{ items.name }}
            </p></b-form-radio
          >
        </b-card>
        <div class="flex justify-between pt-4">
          <div class="pl-2">
            <p
              class="text-lime-400 text-lg font-bold"
              v-if="selected.correctAns == true"
            >
              Correct Answer!
            </p>
            <p
              class="text-red-400 text-lg font-bold"
              v-else-if="selected.correctAns == false"
            >
              Wrong Answer!
            </p>
            <!-- <span>1 is the correct answer</span>
            <span v-if="selected != ''"> {{ quesData[n].explaination }}</span> -->
          </div>
          <!-- <div class="pl-2">
            <p class="text-danger text-lg font-bold">Wrong Answer!</p>
            <span>Please try again</span>
          </div> -->
          <div class="text-right">
            <!-- <base-button
              v-if="n + 1 > 1 && quesData.length"
              type="primary"
              class="rounded-full px-8 py-1.5"
              @click="n--, (selected = '')"
            >
              Previus Question
            </base-button> -->
            <base-button
              v-if="n + 1 <= quesData.length - 1"
              type="primary"
              class="rounded-full px-8 py-1.5"
              @click="n++, (selected = '')"
            >
              Next Question
            </base-button>
            <base-button
              v-else
              type="primary"
              class="rounded-full px-8 py-1.5"
              @click="submit()"
              >Submit</base-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      question: [
        {
          option: "diluting in it",
        },
        {
          option: "diluting in it",
        },
        {
          option: "diluting in it",
        },
        {
          option: "diluting in it",
        },
      ],
      selected: {},
      quesData: [],
      result: [],
      n: 0,
    };
  },

  methods: {
    async submit() {
      const { data } = await this.$store.dispatch(
        "learningTracker/AddLearningData",
        {
          course: this.assessments[0].course[0],
          student: this.userData._id,
          chapter: this.assessments[0]._id,
          status: "completed",
        }
      );
      this.$swal.fire({
        text: "Answer Submited Successfuly",
        icon: "success",
        confirmButtonText: "Ok",
        confirmButtonColor: "#60d394",
        showCancelButton: false,
      });
    },

    selectedQnA() {
      this.result.push(this.selected);
      // console.log(this.result);
      // console.log(this.result.length);
    },
  },
  watch: {
    assessments(newVal) {
      if (newVal) {
        newVal.forEach((element) => {
          this.quesData = element.question;
        });
        this.n = 0;
        this.selected = "";
      }
    },
  },
  mounted() {
    if (!this.assessments.length) {
      this.quesData = [];
    }
  },
  computed: {
    ...mapState("eLearning", { assessments: "assessments" }),
    ...mapState("auth", ["userData"]),
  },
};
</script>

<style>
.custom-control-label::before {
  top: 0.3rem;
  left: -2rem;
}
.custom-control-label::after {
  top: 0.3rem;
  left: -2rem;
  border: 2px solid #fff;
  border-radius: 50%;
}
.qcard:active {
  background-color: #0d3e72;
  color: #fff;
}
.qcard {
  background-color: #ededed;
}
.text-lime-400 {
  color: rgb(132 204 22);
}
</style>
